import { hot } from 'react-hot-loader'
import React from 'react'
import styled, { createGlobalStyle } from 'styled-components'
import SmartModuleLoader from './components/ModuleLoader/SmartModuleLoader'
import SmartTrackingLoader from './components/Tracking/SmartTrackingLoader'
import SmartTrackingManager from './components/Tracking/SmartTrackingManager'
import { BASE_BREAKPOINTS } from '../utils/enhancers/withResponsive'

import Layout from './layout'

const Global = createGlobalStyle`
  body {
    background-color: white;
  }
`

const AppContainer = styled.div`
  padding-top: 32px;
  margin-bottom: 64px;

  @media screen and (max-width: ${BASE_BREAKPOINTS.md}px) {
    margin-bottom: 24px;
  }
`

function App() {
  return (
    <AppContainer>
      <Global />
      <SmartTrackingLoader />
      <SmartTrackingManager />
      <Layout>
        <SmartModuleLoader />
      </Layout>
    </AppContainer>
  )
}

export default hot(module)(App)
